import React from "react";
import { useNavigate } from "react-router-dom";

export default function Impressum() {
const navigate = useNavigate();
const goToHome=()=>{
    navigate("/");
  }

  return (
    <div className="bg-orange-100 min-h-screen">
      {/* Header */}
      <header className="text-center py-6 bg-orange-400 text-white p-6 m-0">
        <h1 className="text-4xl font-bold">BioOrangen.ch</h1>
        <p className="mt-2 text-md">Impressum</p>
      </header>

      {/* Header Image */}
      <div
        className="w-full h-56 bg-cover bg-center"
        style={{ backgroundImage: `url(${require('./images/bioorangen14.jpg')})` }}
      ></div>

      <div className="p-4">
        {/* Impressum Section */}
        <button onClick={(goToHome) => window.location.href = '/'} className="ml-4 mt-4 bg-orange-500 text-white px-4 py-2 rounded-lg shadow hover:bg-orange-600 transition">← Zurück</button>
        <section className="my-10 max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-3xl font-semibold">Kontakt</h2>
          <p className="mt-4 text-md">
            Rietstrasse 28<br />
            8733 Eschenbach<br />
            Schweiz
          </p>
          <p className="mt-4 text-md">
            <b>E-Mail:</b> <a href="mailto:conny.helbling@gmx.ch" className="text-orange-600 hover:underline">conny.helbling@gmx.ch</a><br />
          </p>
          <p className="mt-4 text-md">
            <b>Vertretungsberechtigte Person:</b><br />
            Cornelia Helbling
          </p>
        </section>

        {/* Haftungsausschluss */}
        <section className="my-10 max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-3xl font-semibold">Haftungsausschluss</h2>
          <p className="mt-4 text-md leading-relaxed whitespace-pre-line">
            Der Verfasser übernimmt keine Verantwortung für die Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen auf dieser Webseite.
            Haftungsansprüche gegen den Verfasser wegen Schäden materieller oder immaterieller Natur, die durch den Zugriff, die Nutzung oder Nichtnutzung der veröffentlichten Informationen,
            durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen. Alle Angebote sind freibleibend und unverbindlich.
            Der Verfasser behält sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne separate Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung
            zeitweise oder endgültig einzustellen.
          </p>
        </section>

        {/* Links */}
        <section className="my-10 max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-3xl font-semibold">Haftungsausschluss für Inhalte und Links</h2>
          <p className="mt-4 text-md leading-relaxed">
            Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs.
            Eine Haftung für solche Webseiten wird vollumfänglich abgelehnt. Der Zugang und die Nutzung solcher Webseiten erfolgen auf eigene Gefahr des Nutzers oder der Nutzerin.
          </p>
        </section>

        {/* Urheberrecht */}
        <section className="my-10 max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-3xl font-semibold">Urheberrechtserklärung</h2>
          <p className="mt-4 text-md leading-relaxed whitespace-pre-line">
            Das Urheberrecht sowie alle anderen Rechte an den Inhalten, Bildern, Fotos und anderen Dateien auf der Webseite gehören ausschliesslich oder den ausdrücklich benannten Rechtsinhabern.
            Die Gestaltung dieser Angaben erfolgte mit Unterstützung durch den dartera Impressum-Generator.
            Jede Art der Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung ausserhalb der Grenzen des Urheberrechts bedürfen der vorherigen schriftlichen Zustimmung
            des jeweiligen Rechteinhabers.
          </p>
        </section>
      </div>

      {/* Footer */}
      <footer className="text-center py-8">
        © BioOrangen.ch | Rietstrasse 28, 8733 Eschenbach
      </footer>
    </div>
  );
}